export default function () {
  return {
    all: [],
  };
}
